import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { removeFromWishlist, addToCart } from "../actions/cartActions";
import { utils } from "../common/utils";
import { showSuccess } from "../common/iziToast";
import * as Icons from "../common/icons";
import { withTranslation } from 'react-i18next';
import ExtendedLink  from "../components/ExtendedLink";
import CurrencyFormat from '../components/CurrencyFormat';

class WishlistLine extends Component {
    constructor(props) {
        super(props);
        const { line } = this.props;
        this.state = {
            defaultQuantity: 1,
            totalQuantityPrice: line.specialPrice * line.quantity,
            quantity: line.quantity
        };
        //  this.onRemoveLine = this.onRemoveLine.bind(this);
    }


    onAddToCart = e => {
        const { t, line } = this.props;
        this.props.addToCart(
            line,
            this.state.defaultQuantity,
            line.originalPrice,
            line.specialPrice,
            line.stockItemId
        );
        this.props.removeFromWishlist(this.props.line.id);
        showSuccess(
            t("Add to Cart"),
            `${t("successfuly added")}${line.title} ${t("to your cart!")}`,
            Icons.CART
        );
    };

    onRemoveLine(e) {
        this.props.removeFromWishlist(this.props.line.id);
    }

    render() {
        const { t, line, settings } = this.props;
        if (!line) return <div />;

        const lineLink = `/products/${line.id}`;

        return (
            <tr>
                <td>
                    <div className="product-item">
                        <ExtendedLink to={lineLink} className="product-thumb">
                            <img
                                src={ line.thumbnail ? line.thumbnail : "img/brands/06.png" }
                                alt={line.title}
                            />
                        </ExtendedLink>
                        <div className="product-info">
                            <h4 className="product-title">
                                <ExtendedLink to={lineLink}>{line.title}</ExtendedLink>
                                <div className="text-lg text-medium text-muted"><CurrencyFormat value={line.specialPrice} settings={settings} /></div>
                            </h4>
                        </div>
                    </div>
                </td>
                <td className="text-center">
                    <button
                        onClick={this.onAddToCart.bind(this)}
                        className="btn btn-success btn-sm"
                    >
                        {t("Add to cart")}
                    </button>
                </td>
                <td className="text-center">
                    <a href={null} role="button"
                        className="remove-from-cart"
                        data-toggle="tooltip"
                        title={t("Remove item")}
                        onClick={this.onRemoveLine.bind(this)}
                    >
                        <i className="icon-cross" />
                    </a>
                </td>
            </tr>
        );
    }
}



export default withTranslation()(connect(null, { removeFromWishlist, addToCart })(WishlistLine));
